import React from 'react';

const IconStar = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="feather leetcode-icon">
    <title>LeetCode</title>
    <path d="M12 4 L12 20 L20 20" />
  </svg>
);

export default IconStar;
